import React from "react";
import { arrayOf, shape, string } from "prop-types";
import SubSectionCard from "../SubSectionCard";

import "./cards-grid.m.css";

const CardsGrid = ({ cards, ...props }) => {
  return (
    <div styleName="cards-grid" {...props}>
      {cards?.map((card, index) => {
        const { title, content } = card || {};
        return (
          <SubSectionCard
            key={index}
            title={title}
            content={content}
          />
        );
      })}
    </div>
  );
};

CardsGrid.propTypes = {
  cards: arrayOf(
    shape({
      title: string.isRequired,
      content: string.isRequired
    })
  ).isRequired
};

export default CardsGrid;